import { Card } from 'antd';
import AdminSidebar from '../Components/Sidebar';
import { getProvidersList } from '../redux/slices/adminSlice';
import { useNavigate } from 'react-router';
import TableComponent from '../Components/TableComponent';

function ProviderList() {
    const navigate = useNavigate()

    const columns = [
        {
            title: 'First Name',
            dataIndex: 'first_name',
            key: 'first_name',
        },
        {
            title: 'Last Name',
            dataIndex: 'last_name',
            key: 'last_name',
        },
        {
            title: 'Email',
            dataIndex: 'email',
            key: 'email',
        },
        {
            title: 'User Type',
            dataIndex: 'user_type',
            key: 'user_type',
        },
        {
            title: 'Action',
            dataIndex: 'key',
            key: 'key',
            render: (_, record) => <a onClick={() => viewData(record?.key)}>View</a>,
        },
    ];

    const viewData = async (id) => {
        navigate(`/admin/provider/${id}`)
    }

    return (
        <>
            <AdminSidebar renderContent={
                <Card
                    title="Providers"
                    style={{ marginBottom: 24 }}
                >
                    <TableComponent
                        listData={getProvidersList}
                        columns={columns}
                        placeholder="Search providers..."
                    />
                </Card>
            } />

        </>
    );
}

export default ProviderList;